import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatToUTCPlusOne = (dateString) => {
  // Parse the input date string as a Date object
  const date = new Date(dateString);

  // Get the UTC+1 offset in milliseconds (1 hour = 60 minutes * 60 seconds * 1000 milliseconds)
  const utcPlusOneOffset = 1 * 60 * 60 * 1000;

  // Adjust the date by adding the UTC+1 offset
  const adjustedDate = new Date(date.getTime() + utcPlusOneOffset);

  // Format the date as 'YYYY-MM-DD / HH:mm'
  const year = adjustedDate.getFullYear();
  const month = String(adjustedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(adjustedDate.getDate()).padStart(2, "0");
  const hours = String(adjustedDate.getHours()).padStart(2, "0");
  const minutes = String(adjustedDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} / ${hours}:${minutes}`;
};

export const formatDate = (dateString) => {
  // Parse the input date string as a Date object
  const date = new Date(dateString);

  // Get the UTC+1 offset in milliseconds (1 hour = 60 minutes * 60 seconds * 1000 milliseconds)
  const utcPlusOneOffset = 1 * 60 * 60 * 1000;

  // Adjust the date by adding the UTC+1 offset
  const adjustedDate = new Date(date.getTime() + utcPlusOneOffset);

  // Format the date as 'YYYY-MM-DD / HH:mm'
  const year = adjustedDate.getFullYear();
  const month = String(adjustedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(adjustedDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export function formatFullDate(dateString) {
  const date = new Date(dateString);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}
// formatFullDate("2025-04-14T12:43:22.000000Z"); // "14 Apr, 2025"

export function formatTime(dateString) {
  const date = new Date(dateString);
  const options = { hour: 'numeric', minute: '2-digit', hour12: true };
  return date.toLocaleTimeString('en-US', options).toUpperCase();
}
// formatTime("2025-04-14T12:43:22.000000Z"); // "12:43 PM"

export const convertToUTC = (time) => {
  if (!time) return "";

  // Create a Date object using the current date and provided time
  const [hours, minutes] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);

  // Convert to UTC and format as HH:MM
  const utcHours = date.getUTCHours().toString().padStart(2, "0");
  const utcMinutes = date.getUTCMinutes().toString().padStart(2, "0");

  return `${utcHours}:${utcMinutes}`;
};

export function formatTo12Hour(time) {
  const [hourStr, minute] = time.split(":");
  const hour = parseInt(hourStr, 10);

  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;

  return `${hour12}:${minute} ${period}`;
}
// formatTo12Hour("13:45"); // "1:45 PM"


export function convertUtcToLocal12Hour(utcTime) {
  const today = new Date().toISOString().split("T")[0]; // e.g., "2025-08-05"
  const utcString = `${today}T${utcTime}:00Z`; // "2025-08-05T09:00:00Z"

  const date = new Date(utcString); // Date object in local time zone

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const minuteFormatted = minutes < 10 ? `0${minutes}` : `${minutes}`;

  return `${hour12}:${minuteFormatted} ${period}`;
}
// convertUtcToLocalTime("09:00"); 
// In Nigeria (UTC+1), this will return: "10:00 AM"


export function convertUtcToLocalTime(utcTime = "00:00") {
  const today = new Date().toISOString().split("T")[0]; // e.g., "2025-08-05"
  const utcString = `${today}T${utcTime}:00Z`; // "2025-08-05T09:00:00Z"

  const date = new Date(utcString); // Local time conversion

  const hours = date.getHours(); // 0–23
  const minutes = date.getMinutes();
  const hourFormatted = hours < 10 ? `0${hours}` : `${hours}`;
  const minuteFormatted = minutes < 10 ? `0${minutes}` : `${minutes}`;

  return `${hourFormatted}:${minuteFormatted}`;
}

// convertUtcToLocalTime("09:00"); 
// In Nigeria (UTC+1), this will return: "10:00 AM"


export function formatDisplay(value) {
  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(", ") : "--";
  }
  // return value && value.trim() !== "" ? value : "--";
}


export function convertTargetToArray(target){
  if (!target) return [];
  return target.split(",").map(url => url.trim());
}

// Example usage:
// const target = "https://example.com,http://example.com";
// const result = convertTargetToArray(target);

// console.log(result);
// ["https://example.com", "http://example.com"]
